import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Seguir dependiendo únicamente de recomendaciones.',
    cost: 'No saber qué publicar.'
  }, {
    without: 'No tener una estrategia clara.',
    cost: 'Sentir que nadie ve tu trabajo.'
  }, {
    without: 'No transmitir confianza online.',
    cost: 'No responder consultas de forma profesional.'
  }, {
    without: 'Tener semanas con pocas reservas.',
    cost: 'Seguir esperando que las consultas aparezcan solas.'
  }, {
    without: 'No aprovechar todo el potencial de tu formación.',
    cost: 'Seguir invisible para las personas que hoy necesitan exactamente lo que hacés.'
  }, {
    without: 'Sin un sistema',
    cost: 'La próxima semana será igual. El próximo mes será igual. Y probablemente el próximo año también.'
  }];
  return <Section data-id="element-15">
      <div className="text-center mb-12" data-id="element-16">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-darkGreen" data-id="element-17">
          <span className="mr-3" data-id="element-18">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="hidden md:block" data-id="element-20">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-21">
            <div className="font-serif font-bold text-lg text-brand-aqua" data-id="element-22">
              Sin el Kit Digital para Terapeutas
            </div>
            <div className="font-serif font-bold text-lg text-brand-error" data-id="element-23">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-24">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-error/10 bg-white/70" data-id="element-25">
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-26">
                  {row.without}
                </div>
                <div className="text-sm text-brand-error/90 font-medium" data-id="element-27">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-28">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-error/10 bg-white/70 space-y-2" data-id="element-29">
              <p className="text-sm font-medium text-brand-text" data-id="element-30">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-error/90 font-medium" data-id="element-31">
                <span className="text-brand-error shrink-0" data-id="element-32">→</span>
                <span className="text-sm" data-id="element-33">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-34">
        
      </div>
    </Section>;
};